module.exports = __webpack_public_path__ + "static/media/logo.b59cdf6a.ico";